import { createContext, useContext } from "react";

export interface OpenFixDateOptions {
  /** Créneau à présélectionner (sinon : le créneau en tête). */
  slotId?: string | null;
  /** « Clôturer sans fixer de date » : l'ancien comportement de l'appelant. */
  onCloseWithoutDate?: () => void | Promise<void>;
}

/**
 * Ouvre la fenêtre « Fixer la date » depuis n'importe quel bouton de clôture
 * rendu à l'intérieur des résultats (menu du connecté, panneau d'admin invité,
 * bandeau « créneau en tête »). `null` hors des résultats : l'appelant garde
 * alors son comportement historique.
 */
export const FixDateContext = createContext<((opts?: OpenFixDateOptions) => void) | null>(null);

export const useOpenFixDate = () => useContext(FixDateContext);
